import { TableWithLayoutSettings } from '@Components/Tables/TableWithLayoutSettings';
import type { ApiOrderPosition, ApiWeighingSlip } from '@Model';
import { Column, formatFloat } from '@synqo/frontend-component-library';
import { EnumFrontendLayoutSetting, getShortUnitLabel } from '@Model';
import { useCallback } from 'react';

export interface ExpandedWeighingSlipSelectionProps {
    position: ApiOrderPosition;
    onSelect: (orderPositionId: string, weighingSlipId: string | undefined) => boolean;
}

const weighingSlipColumn: Column<ApiWeighingSlip>[] = [
    {
        name: 'number',
        label: 'WS Nr.',
    },
    {
        name: 'gross_weighing_date',
        label: 'Datum',
        type: 'datetime',
    },
    {
        name: 'gross_weight',
        label: 'Bruttogewicht in t',
        renderCell: ({ cellData, rowData }) =>
            `${formatFloat(cellData as number, 2)} ${getShortUnitLabel(rowData.unit)}`,
    },
];

export function ExpandedWeighingSlipSelection({ position, onSelect }: ExpandedWeighingSlipSelectionProps) {
    const onSelectWeighingSlip = useCallback(
        (ws: ApiWeighingSlip) => onSelect(position.id, ws.id),
        [onSelect, position.id],
    );

    return (
        <TableWithLayoutSettings
            layoutSettingsContext={EnumFrontendLayoutSetting.WeighingSlipsTableLayout}
            columns={weighingSlipColumn}
            items={position.weighing_slips}
            name={'weighing_slips_for_position_' + position.id}
            onSelect={onSelectWeighingSlip}
            disableTopToolbar
        />
    );
}
